"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconChoice = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 14 14",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M6.9967 3.3333C7.9133 3.3333 8.6633 2.5833 8.6633 1.6667 8.6633.75 7.9133 0 6.9967 0 6.08 0 5.33.75 5.33 1.6667 5.33 2.5833 6.08 3.3333 6.9967 3.3333ZM6.9967 5C6.08 5 5.33 5.75 5.33 6.6667 5.33 7.5833 6.08 8.3333 6.9967 8.3333 7.9133 8.3333 8.6633 7.5833 8.6633 6.6667 8.6633 5.75 7.9133 5 6.9967 5ZM6.9967 10C6.08 10 5.33 10.75 5.33 11.6667 5.33 12.5833 6.08 13.3333 6.9967 13.3333 7.9133 13.3333 8.6633 12.5833 8.6633 11.6667 8.6633 10.75 7.9133 10 6.9967 10Z"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconChoice')(IconChoice);